/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Injectable } from '@angular/core';
import Color from 'color';

import {
  mapThemeBorderRadiusesStoreModelToThemeBorderRadiusValues,
  mapThemeColorsStoreModelToThemeColorVariableValues,
  mapThemeDropShadowsStoreModelToThemeDropShadowValues,
  mapThemeFitlersStoreModelToFilterValues,
} from '@core/stores/auth/mappings';
import { ThemeColors } from '@core/theme/theme-colors';
import { GeneratedThemeDropShadows } from '@core/theme/theme-drop-shadows';
import { ThemeColorVariableValues } from '@core/theme/types';

import { ThemeStoreModel } from '@domain/theme/theme.models';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public setCssVariables(theme: ThemeStoreModel): void {
    const root = document.querySelector<HTMLElement>(':root')!;

    const colorVariableValues = mapThemeColorsStoreModelToThemeColorVariableValues(theme.colors);
    const borderRadiusValues = mapThemeBorderRadiusesStoreModelToThemeBorderRadiusValues(theme.borderRadiuses);
    const dropShadowValues = mapThemeDropShadowsStoreModelToThemeDropShadowValues(theme.dropShadows, theme.colors);
    const filterValues = mapThemeFitlersStoreModelToFilterValues(theme.filters);
    const generatedDropShadowValues = this.generateDropShadowsFromColors(colorVariableValues);

    Object.keys(colorVariableValues).forEach((key) => {
      root.style.setProperty(key, colorVariableValues[key as keyof typeof colorVariableValues]);
    });

    Object.keys(borderRadiusValues).forEach((key) => {
      root.style.setProperty(key, borderRadiusValues[key as keyof typeof borderRadiusValues]);
    });

    Object.keys(dropShadowValues).forEach((key) => {
      root.style.setProperty(key, dropShadowValues[key as keyof typeof dropShadowValues]);
    });

    Object.keys(filterValues).forEach((key) => {
      root.style.setProperty(key, filterValues[key as keyof typeof filterValues]);
    });

    Object.keys(generatedDropShadowValues).forEach((key) => {
      root.style.setProperty(key, generatedDropShadowValues[key]);
    });
  }

  public setRootClass(isDark: boolean): void {
    const root = document.querySelector<HTMLElement>(':root')!;

    if (isDark) {
      if (!root.classList.contains('dark')) {
        root.classList.add('dark');
      }
    } else {
      if (root.classList.contains('dark')) {
        root.classList.remove('dark');
      }
    }
  }

  private generateDropShadowsFromColors(colorVariableValues: ThemeColorVariableValues): Record<string, string> {
    return Object.values(GeneratedThemeDropShadows).reduce(
      (acc, value) => {
        return {
          ...acc,
          [value.cssVariable]: `0 7px 10px ${Color(colorVariableValues[ThemeColors[value.themeColorKey]]).alpha(0.3).string()}`,
        };
      },
      {} as Record<string, string>
    );
  }
}
